/**
 * Calculates the number of whole hours between two dates.
 * 
 * @param eventDate - The target date (can be Date object, ISO string, or timestamp)
 * @param currentDate - The reference date to compare against (defaults to current time if not provided)
 * @returns The number of whole hours between the dates, always as a positive integer
 * 
 * @example
 * // Basic usage
 * const event = new Date('2025-06-14T12:00:00Z');
 * const hours = hoursUntilEvent(event);
 * console.log(hours); // e.g., 24
 */
const hoursUntilEvent = (
  eventDate: Date | string | number,
  currentDate: Date | string | number = new Date()
): number => {
  const eventTime = new Date(eventDate).getTime();
  const currentTime = new Date(currentDate).getTime();
  
  if (isNaN(eventTime)) {
    throw new Error('Invalid event date provided');
  }
  
  const diffInMs = Math.abs(eventTime - currentTime);
  return Math.floor(diffInMs / (1000 * 60 * 60));
}

export {hoursUntilEvent};